import React from "react";
import { FormControl, FormHelperText } from "@mui/material";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import "./PhoneNumberDropdown.css";

const PhoneNumberDropdown = ({
  value,
  onChange,
  error = "",
  defaultCountry = "de",

  width = "100%",
  inputWidth = "100%",

  className,
  style,
  sx,
  disabled = false,

  ...props
}) => {
  const handleChange = (phone, country) => {
    if (disabled) return;

    onChange({
      phone,
      countryCode: `+${country.country.dialCode}`,
      country,
    });
  };

  return (
    <FormControl
      fullWidth={width === "100%"}
      error={!!error}
      className={className}
      sx={{
        width,
        ...sx,
      }}
      style={style}
      {...props}
    >
      <PhoneInput
        defaultCountry={defaultCountry}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className="custom-phone-input"
        style={{
          width: inputWidth,
        }}
        inputStyle={{
          width: "100%",
        }}
      />

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default PhoneNumberDropdown;